module.exports = __webpack_public_path__ + "img/CATEGORY ICON-25.65db6ff3.png";